import { connect } from 'react-redux';

import { IAppState, Dispatch } from '../../../../../../../common/state';
import { EFacility } from '../../../../../../../json_query/types';
import { changeFacility } from '../../../../../../state/advanced/facilities';
import { facilitiesFromJsonQuery } from '../../../../../../../utils/facilities';

import { Facilities as FacilitiesComponent, IFacilitiesProps } from './facilities';

type TFacilitiesStateProps = Pick<IFacilitiesProps, 'facilities'>;
type TFacilitiesDispatchProps = Pick<IFacilitiesProps, 'onChange'>;

export function mapStateToProps(state: IAppState): TFacilitiesStateProps {
  return {
    facilities: facilitiesFromJsonQuery(state.filters.jsonQuery),
  };
}

export function mapDispatchToProps(dispatch: Dispatch): TFacilitiesDispatchProps {
  return {
    onChange: (facility: EFacility, value: boolean) => {
      dispatch(changeFacility(facility, value));
    },
  };
}

export const Facilities = connect(mapStateToProps, mapDispatchToProps)(FacilitiesComponent);
